/**
 * Social Sharing Block - Frontend JavaScript
 * Handles copy to clipboard functionality
 */

document.addEventListener('DOMContentLoaded', function() {
    // Find all copy link buttons
    const copyButtons = document.querySelectorAll('.social-share-button.copy-link');
    
    copyButtons.forEach(button => {
        button.addEventListener('click', async function(e) {
            e.preventDefault();
            
            const url = this.getAttribute('data-url');
            const copyText = this.querySelector('.copy-text');
            const originalText = copyText.textContent;
            
            try {
                // Try modern clipboard API first
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(url);
                } else {
                    // Fallback for older browsers
                    const textArea = document.createElement('textarea');
                    textArea.value = url;
                    textArea.style.position = 'fixed';
                    textArea.style.left = '-999999px';
                    textArea.style.top = '-999999px';
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    document.execCommand('copy');
                    textArea.remove();
                }
                
                // Visual feedback
                this.classList.add('copied');
                copyText.textContent = 'Copié !';
                
                // Reset after 2 seconds
                setTimeout(() => {
                    this.classList.remove('copied');
                    copyText.textContent = originalText;
                }, 2000);
                
            } catch (err) {
                console.error('Erreur lors de la copie:', err);
                
                // Error feedback
                copyText.textContent = 'Erreur';
                setTimeout(() => {
                    copyText.textContent = originalText;
                }, 2000);
            }
        });
    });
    
    // Optional: Add keyboard support for copy buttons
    copyButtons.forEach(button => {
        button.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });
    });
});